import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { useDataLayerValue } from "../../Reducer/DataLayer";
import Upload from "../Upload,";

import img from "../../_utils/q3.jpg";
const ImageVideo = (props) => {
  const classes = useStyles();

  const [{ images, videos }, dispatch] = useDataLayerValue();

  const handleImages = async () => {
    await fetch("https://api.thecatapi.com/v1/images/search")
      .then((res) => res.json())
      .then((data) => {
        dispatch({
          type: "ADD_IMAGE",
          payload: { image: data[0]?.url },
        });
      })
      .catch((err) => console.error(err?.message));
  };

  const handleVideos = async () => {
    await fetch("https://api.thecatapi.com/v1/images/search")
      .then((res) => res.json())
      .then((data) => {
        dispatch({
          type: "ADD_VIDEO",
          payload: { video: data[0]?.url },
        });
      })
      .catch((err) => console.error(err.message));
  };

  return (
    <div className={classes.root}>
      {/* IMAGES */}

      {[images, videos].map((arr, index) => (
        <div className={classes.box} key={index}>
          <div className="text-center">
            Upload {index === 0 ? "Image" : "video"}
          </div>
          <div className="d-flex flex-column">
            <div>
              {arr?.map((img, index) => (
                <img
                  src={img}
                  alt={`img ${index}`}
                  className={classes.catImg}
                  key={index}
                />
              ))}
            </div>{" "}
            <img src={img} alt="" />
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={classes.uploadButton}
              startIcon={<CloudUploadIcon />}
              onClick={index === 0 ? handleImages : handleVideos}
            >
              {index === 0 ? "Image" : "Video"}
            </Button>
            <Upload width="100%" height="100%" />
          </div>
        </div>
      ))}
    </div>
  );
};
export default ImageVideo;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f2f4fc",
    borderRadius: "0.5rem",
    display: "flex",
    margin: "1rem 0.125rem",
    padding: "1rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      margin: "0",
      padding: ".25rem",
    },
  },
  box: {
    flex: 1,
    backgroundColor: "#d2d4d9",
    borderRadius: "0.5rem",
    display: "flex",
    flexDirection: "column",
    margin: "0 0.75rem 0 0.5rem",
    overflow: "hidden",
    padding: "0.125rem 0.25rem",
    width: "inherit",
    [theme.breakpoints.down("sm")]: {
      margin: ".75rem",
      minHeight: "8rem",
    },
  },
  videos: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#d2d4d9",
    borderRadius: "0.5rem",
    margin: "0 0.5rem 0 0.75rem ",
    width: "inherit",
    [theme.breakpoints.down("sm")]: {
      margin: ".75rem",
      minHeight: "8rem",
    },
  },
  catImg: {
    borderRadius: "0.325rem",
    objectFit: "cover",
    width: "6rem",
  },
  uploadButton: {
    margin: ".5rem 0",
    alignSelf: "center",
  },
}));
